// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction7_wrapper__9+RxF","button":"introduction7_button__aPh6b"};